export const NEWSFEED_REQUEST = "NEWSFEED_REQUEST";
export const NEWSFEED_SUCCESS = "NEWSFEED_SUCCESS";
export const NEWSFEED_FAILURE = "NEWSFEED_FAILURE";